"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RemoveUnusedComponents = void 0;

var utils_1 = require("../../utils");

var RemoveUnusedComponents = function RemoveUnusedComponents() {
  var components = new Map();

  function registerComponent(location, componentType, name) {
    var _a;

    components.set(location.absolutePointer, {
      used: ((_a = components.get(location.absolutePointer)) === null || _a === void 0 ? void 0 : _a.used) || false,
      componentType: componentType,
      name: name
    });
  }

  return {
    ref: {
      leave: function leave(ref, _ref) {
        var type = _ref.type,
            resolve = _ref.resolve,
            key = _ref.key;

        if (['Schema', 'Parameter', 'Response', 'SecurityScheme'].includes(type.name)) {
          var resolvedRef = resolve(ref);
          if (!resolvedRef.location) return;
          components.set(resolvedRef.location.absolutePointer, {
            used: true,
            name: key.toString()
          });
        }
      }
    },
    DefinitionRoot: {
      leave: function leave(root, ctx) {
        var data = ctx.getVisitorData();
        data.removedCount = 0;
        var rootComponents = new Set();
        components.forEach(function (usageInfo) {
          var used = usageInfo.used,
              name = usageInfo.name,
              componentType = usageInfo.componentType;

          if (!used && componentType) {
            rootComponents.add(componentType);
            delete root[componentType][name];
            data.removedCount++;
          }
        });

        var _iterator = _createForOfIteratorHelper(rootComponents),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var component = _step.value;

            if (utils_1.isEmptyObject(root[component])) {
              delete root[component];
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    },
    NamedSchemas: {
      Schema: function Schema(schema, _ref2) {
        var location = _ref2.location,
            key = _ref2.key;

        if (!schema.allOf) {
          registerComponent(location, 'definitions', key.toString());
        }
      }
    },
    NamedParameters: {
      Parameter: function Parameter(_parameter, _ref3) {
        var location = _ref3.location,
            key = _ref3.key;
        registerComponent(location, 'parameters', key.toString());
      }
    },
    NamedResponses: {
      Response: function Response(_response, _ref4) {
        var location = _ref4.location,
            key = _ref4.key;
        registerComponent(location, 'responses', key.toString());
      }
    },
    NamedSecuritySchemes: {
      SecurityScheme: function SecurityScheme(_securityScheme, _ref5) {
        var location = _ref5.location,
            key = _ref5.key;
        registerComponent(location, 'securityDefinitions', key.toString());
      }
    }
  };
};

exports.RemoveUnusedComponents = RemoveUnusedComponents;